import React from 'react';

const CheckIcon = () => (
  <svg width="14" height="14" fill="none" stroke="#fff" strokeWidth="3" viewBox="0 0 24 24">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export default function WizardSteps({ steps, currentStep }) {
  return (
    <div className="wizard-steps">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isComplete = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <React.Fragment key={label}>
            <div className={`wizard-step ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''}`}>
              <div className="wizard-step-circle">
                {isComplete ? <CheckIcon /> : stepNumber}
              </div>
              <span className="wizard-step-label">{label}</span>
            </div>
            {index < steps.length - 1 && (
              <div className={`wizard-step-line ${isComplete ? 'complete' : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}